import { useRef } from "react";
import ky from "ky-universal";
import useSWRMutation from "swr/mutation";
import { v4 as uuidv4 } from "uuid";
const isOfType = (varToBeChecked, propertyToCheckFor) => varToBeChecked[propertyToCheckFor] !== undefined;
export const useMutation = (requestFunction, params) => {
    const { body, queryParams, headers, queryKey, ...options } = params || {};
    const mutationKey = useRef(queryKey !== null && queryKey !== void 0 ? queryKey : uuidv4());
    const request = async (_key, { arg: requestBody }) => {
        /*
          Need better way to work out if this is
          a react event. We might want to add to a component
          <button onclick={sendRequest} /> but we don't want to
          use the event [(event) => sendRequest(event)] and try to
          JSON.stringify the event.
        */
        const bodyForRequest = !!requestBody &&
            !isOfType(requestBody, "currentTarget")
            ? requestBody
            : body;
        if (bodyForRequest == null) {
            throw Error("Body must be provided");
        }
        try {
            const data = await requestFunction(bodyForRequest, queryParams, headers);
            return data;
        }
        catch (error) {
            // only throw error if it is an actual HTTPError
            if (error instanceof ky.HTTPError) {
                throw error;
            }
        }
    };
    const { trigger, data, error, isMutating, reset } = useSWRMutation(mutationKey.current, request, {
        throwOnError: false,
        ...options,
    });
    return [trigger, { data, error, isMutating, reset }];
};
